export class ApiError extends Error {
  constructor(
    message: string,
    public readonly status: number,
    public readonly payload: unknown
  ) {
    super(message);
  }
}

export async function apiRequest<T>(path: string, options: RequestInit = {}): Promise<T> {
  const response = await fetch(path, {
    ...options,
    headers: options.body
      ? { 'Content-Type': 'application/json', ...options.headers }
      : options.headers
  });
  let payload: unknown = {};
  try {
    payload = await response.json();
  } catch {
    // Empty responses are valid for endpoints without a body.
  }
  if (!response.ok) {
    const message = typeof payload === 'object' && payload && 'error' in payload
      ? String(payload.error)
      : 'Noe gikk galt. Prøv igjen.';
    throw new ApiError(message, response.status, payload);
  }
  return payload as T;
}
